<!-- <mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
    </button>
    <span>Event Sponsorship Application</span>
    <span class="example-spacer"></span>
    <button [fxShow.lt-md]="true" [fxShow]="false" mat-icon-button
        (click)="toHome()">
        <mat-icon>home</mat-icon>
    </button>
</mat-toolbar> -->
<div class="mobile-action-bar">
    <div class="action-mobile-button warn-button" (click)="onCancel()">Cancel</div>
    <div class="action-mobile-button secondary-button"
        *ngIf="isShowSaveAsDraft"
        (click)="onSaveAsDraft()">Save</div>
    <div class="action-mobile-button primary-button" *ngIf="isShowSaveAsDraft"
        (click)="onSubmit()">Submit</div>
    <div class="action-mobile-button secondary-button"
        *ngIf="isShowSaveButton"
        (click)="onSubmit()">Save
        Change(s)</div>
    <div class="action-mobile-button warn-button" *ngIf="isShowApproveBtn"
        (click)="onWithdrawReject('Rejected')">Reject</div>
    <div class="action-mobile-button primary-button" *ngIf="isShowApproveBtn"
        (click)="onApprove()">Approve</div>
    <!-- <button class="action-mobile-button" fxFlex *ngIf="isShowReassignBtn"
            (click)="onWithdrawReject('Reassigned')" color="primary">Reassign To CIT</button> -->
    <div class="action-mobile-button warn-secondary-button"
        *ngIf="isShowWithdrawBtn"
        (click)="onWithdrawReject('Withdrawn')">Withdraw</div>
</div>
<mat-toolbar
    *ngIf="isFormExpired && (esForm.value.statusId === 2 ||
    esForm.value.statusId === undefined || esForm.value.statusId === null)"
    color="primary" style="background-color: #CE1126">
    <span>Event Sponsorship Application has been expired!</span>
</mat-toolbar>

<!-- General Instruction -->
<div class="info-container">
    <mat-card-subtitle class="leading-9">
        <p>Through event sponsorships, LG&E and KU support non-profit
            programs and activities
            focusing
            on education, environment, economic development, health and
            human services, and diversity.</p>
        <p>
            <a
                href="https://lge-ku.com/sites/default/files/CharitableContributionsExternalUser.pdf"
                target="_blank">General Instructions</a>
        </p>
        <p>
            <b>*</b> = Mandatory
        </p>
    </mat-card-subtitle>
</div>
<div autoscroll="true" class="content"
    [@routeAnimation]="true">
    <form class="form-content" [formGroup]="esForm"
        enctype="multipart/form-data">




        <!-- OrgInfo -->
        <mat-card formGroupName="OrgInfo" fxLayout="column" fxLayoutGap="16px">
            <mat-card-subtitle>
                <b>Organization Information</b>
            </mat-card-subtitle>
            <mat-form-field>
                <input readonly type="text" formControlName="name" matInput
                    placeholder="Organization Name">
            </mat-form-field>
            <mat-card-subtitle>Is "Payable To" name different than the
                Organization Name? *</mat-card-subtitle>
            <mat-radio-group formControlName="payToOption"
                [disabled]="isReadOnly ||
                (esForm.get(['OrgInfo','payToOption']).value === 'Yes' &&
                esForm.get('OrgInfo')['controls'].name.value.length> 80)">
                <mat-radio-button color="primary" value="Yes">Yes</mat-radio-button>
                <mat-radio-button color="primary" value="No">No</mat-radio-button>
            </mat-radio-group>
            <mat-form-field fxLayout="column"
                *ngIf="esForm.get(['OrgInfo','payToOption']).value === 'Yes'">
                <input [readonly]="isReadOnly" type="text"
                    formControlName="payTo" matInput placeholder="Payable To"
                    maxlength="80">
            </mat-form-field>
            <mat-form-field>
                <input type="text" readonly formControlName="EIN" matInput
                    placeholder="EIN">
            </mat-form-field>

            <mat-form-field>
                <input type="text" formControlName="address1" matInput
                    placeholder="Address1" maxlength="35"
                    [attr.disabled]='isReadOnly'>
            </mat-form-field>
            <mat-form-field>
                <input type="text" formControlName="address2" matInput
                    placeholder="Address2" maxlength="35"
                    [attr.disabled]='isReadOnly'>
            </mat-form-field>
            <mat-form-field>
                <input type="text" formControlName="city" matInput
                    placeholder="City" maxlength="50"
                    [attr.disabled]='isReadOnly'>
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="State" formControlName="state"
                    [disabled]='isReadOnly'>
                    <mat-option *ngFor="let state of states" [value]="state">{{state}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <input type="text" formControlName="zipCode" zipCode matInput
                    placeholder="Zip Code" maxlength="10"
                    [attr.disabled]='isReadOnly'>
            </mat-form-field>
            <mat-form-field>
                <input type="text" formControlName="webAddress" matInput
                    placeholder="Web Address" maxlength="35"
                    [attr.disabled]='isReadOnly'>
            </mat-form-field>
            <mat-form-field *ngIf='!isTaxExemptEditable'>
                <input type="text" matInput placeholder="Tax-Exempt Status"
                    maxlength="15"
                    [value]="getTaxExemptStatus(esForm.get(['OrgInfo','subsection_501']).value)"
                    readonly>
            </mat-form-field>
            <mat-form-field *ngIf='isTaxExemptEditable'>
                <mat-select placeholder="Tax Exempt Status"
                    formControlName="subsection_501"
                    [disabled]='isReadOnly'>
                    <mat-option *ngFor="let subsection of taxExemptList"
                        [value]="subsection">
                        {{getTaxExemptStatus(subsection)}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-card-subtitle>Brief statement describing organization's
                purpose/mission and goals. *
            </mat-card-subtitle>
            <mat-form-field>
                <textarea CharLimit [MaxChar]='500' formControlName="orgDesc"
                    matInput matTextareaAutosize
                    matAutosizeMinRows="3" matAutosizeMaxRows="5"
                    [attr.disabled]='isReadOnly'></textarea>
                <mat-hint align="end">Characters count (not includes spaces) 0 /
                    500</mat-hint>
            </mat-form-field>
            <mat-form-field>
                <input type="text" formControlName="president" matInput
                    placeholder="Name of President / CEO / Executive Director."
                    maxlength="25"
                    [attr.disabled]='isReadOnly'>
                <mat-hint>Example: Jane Doe</mat-hint>
            </mat-form-field>
            <mat-form-field>
                <input type="email" matInput placeholder="Email Address"
                    maxlength="254"
                    formControlName="email"
                    [attr.disabled]='isReadOnly'>
                <mat-hint>Example: you@example.com</mat-hint>
            </mat-form-field>
        </mat-card>

        <!--OrgContact Info-->
        <mat-card formGroupName="OrgContactInfo" fxLayout="column"
            fxLayoutGap="16px">
            <mat-card-subtitle>
                <b>Organization Contact Information</b>
            </mat-card-subtitle>
            <br>
            <mat-card-subtitle><b><i><b>
                            *All communication will be directed to the
                            individual listed below.</b></i></b>
            </mat-card-subtitle>
            <mat-form-field>
                <input type="text" matInput placeholder="First Name"
                    maxlength="150"
                    formControlName="firstName"
                    [attr.disabled]='isReadOnly'>
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput placeholder="Last Name"
                    maxlength="150"
                    formControlName="lastName"
                    [attr.disabled]='isReadOnly'>
            </mat-form-field>
            <mat-form-field>
                <input type="text" phone formControlName="phone" maxlength="12"
                    matInput placeholder="Phone Number"
                    [attr.disabled]='isReadOnly'>
                <mat-hint>Example: xxx-xxx-xxxx</mat-hint>
            </mat-form-field>
            <mat-form-field>
                <input type="email" matInput placeholder="Email Address"
                    maxlength="254"
                    formControlName="email"
                    [attr.disabled]='isReadOnly'>
                <mat-hint>Example: you@example.com</mat-hint>
            </mat-form-field>
        </mat-card>

        <!--Additional OrgInfo-->
        <mat-card fxLayout="column" fxLayoutGap="16px">
            <mat-card-subtitle>The following LG&E, KU or ODP employees are
                affiliated with this organization as a board member or regular
                volunteer.*:
            </mat-card-subtitle>
            <mat-form-field>
                <input type="text" matInput placeholder="Employee Name"
                    maxlength="50" formControlName="empName"
                    [attr.disabled]='isReadOnly'>
            </mat-form-field>


            <mat-card-subtitle>Is your organization interested in providing
                volunteer opportunities for LG&E and KU employees? *</mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-radio-group formControlName="isVolunteerProvided"
                    [disabled]='isReadOnly'>
                    <mat-radio-button color="primary"
                        value="Yes">Yes</mat-radio-button>
                    <mat-radio-button color="primary"
                        value="No">No</mat-radio-button>
                </mat-radio-group>
            </mat-card-content>

            <mat-card-subtitle *ngIf="esForm.value.serviceArea === null ||
                esForm.value.serviceArea.length === 0">
                Service Area(s): *</mat-card-subtitle>
            <mat-form-field fxLayout="column">
                <mat-select [disabled]='isReadOnly' placeholder="Service
                    Area(s)" formControlName="serviceArea"
                    multiple [disabled]='isReadOnly'>
                    <mat-option *ngFor="let serviceArea of serviceAreas"
                        [value]="serviceArea">{{serviceArea}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-card-subtitle *ngIf="esForm.value.categoryRequest ===''">Category
                of Request: *</mat-card-subtitle>
            <mat-form-field fxLayout="column">
                <mat-select [disabled]='isReadOnly' placeholder="Category of
                    Request:" formControlName="categoryRequest"
                    disableOptionCentering
                    [disabled]='isReadOnly'>
                    <mat-option *ngFor="let catReq of catReqs" [value]="catReq">{{catReq}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-card-subtitle *ngIf="hasOtherCatReq"
                [ngClass]="{'red-warning':
                esForm.get('categoryRequestOther').invalid}">Please specify
                Other
                Category of Request. *</mat-card-subtitle>
            <mat-card-content *ngIf="hasOtherCatReq">
                <mat-form-field fxLayout="column">
                    <input [readonly]='isReadOnly'
                        formControlName="categoryRequestOther" type="text"
                        matInput
                        maxlength="25">
                    <mat-hint align="end">({{
                        esForm.get('categoryRequestOther').value.length}}/25
                        characters limit)</mat-hint>
                </mat-form-field>
            </mat-card-content>

        </mat-card>

        <!--Event Info-->
        <mat-card fxLayout="column" fxLayoutGap="16px">
            <mat-card-subtitle>
                <b>Event Information</b>
            </mat-card-subtitle>

            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <input [readonly]='isReadOnly' placeholder="Event Name"
                        maxlength="30"
                        formControlName="eventName"
                        matInput type="text">
                    <mat-hint>(Example: Summer Reading Program, General
                        Operating Support, Annual Fundraiser)</mat-hint>
                    <mat-hint align="end">({{
                        esForm.get('eventName').value.length}}/30
                        characters limit)</mat-hint>
                </mat-form-field>

                <mat-form-field>
                    <input [readonly]='isReadOnly' placeholder="Event Location"
                        maxlength="35"
                        formControlName="eventLocation" matInput type="text">
                    <mat-hint>(Example: Louisville, KY)</mat-hint>
                    <mat-hint align="end">({{
                        esForm.get('eventLocation').value.length}}/35
                        characters limit)</mat-hint>
                </mat-form-field>

                <mat-form-field>
                    <input [readonly]='isReadOnly' placeholder="Event Date"
                        maxlength="25"
                        formControlName="eventDate"
                        matInput type="text">
                    <mat-hint align="end">({{
                        esForm.get('eventDate').value.length}}/25
                        characters limit)</mat-hint>
                </mat-form-field>

                <mat-form-field>
                    <input [readonly]='isReadOnly' placeholder="Expected
                        Attendance" maxlength="50"
                        formControlName="attendance" matInput type="text">
                    <mat-hint align="end">({{
                        esForm.get('attendance').value.length}}/50
                        characters limit)</mat-hint>
                </mat-form-field>

                <mat-form-field>
                    <input [readonly]='isReadOnly' DecimalTrail
                        placeholder="Total Event Cost" maxlength="10"
                        [textMask]="{mask: twoDecMask}"
                        formControlName="eventCost" matInput type="text">
                    <span matPrefix>$&nbsp;</span>
                </mat-form-field>

                <mat-form-field>
                    <input [readonly]='isReadOnly' DecimalTrail
                        placeholder="Amount requested from LG&E/KU/ODP"
                        maxlength="10"
                        [textMask]="{mask: twoDecMask}"
                        formControlName="requestedAmount"
                        matInput type="text">
                    <span matPrefix>$&nbsp;</span>
                </mat-form-field>
                <mat-card-subtitle>
                    Event description:*
                </mat-card-subtitle>
                <mat-card-content fxLayout="column">
                    <mat-form-field>
                        <textarea CharLimit [MaxChar]='500'
                            [attr.disabled]='isReadOnly'
                            formControlName="eventDescr" matInput
                            matTextareaAutosize matAutosizeMinRows="2"
                            matAutosizeMaxRows="5"></textarea>
                        <mat-hint align="end">Characters count (not includes
                            spaces) 0 / 500</mat-hint>
                    </mat-form-field>
                </mat-card-content>
                <mat-card-subtitle>
                    Sponsor benefits/recognition received at the requested
                    level. *
                </mat-card-subtitle>
                <mat-card-content fxLayout="column">
                    <mat-form-field>
                        <textarea CharLimit [MaxChar]='1000'
                            [attr.disabled]='isReadOnly'
                            formControlName="recognition"
                            matInput matTextareaAutosize matAutosizeMinRows="2"
                            matAutosizeMaxRows="5"></textarea>
                        <mat-hint align="end">Characters count (not includes
                            spaces) 0 / 1000</mat-hint>
                    </mat-form-field>
                </mat-card-content>

            </mat-card-content>

        </mat-card>

        <!--List Of companies-->
        <mat-card fxLayout="column" fxLayoutGap="16px">
            <mat-card-subtitle>List the top 5 companies/businesses contributing
                to <u><b>this event</b></u>
                and the amount contributed (if applicable).
            </mat-card-subtitle>

            <div class="table-container mat-elevation-z8">

                <table class='compListTable' style="padding: 16px;"
                    formArrayName="companyList">
                    <thead>
                        <tr>
                            <th>No.</th>
                            <th>Company Name</th>
                            <th>Contribution</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr [formGroupName]="i"
                            *ngFor="let company of
                            esForm.get('companyList')['controls']; let i=
                            index">
                            <td>{{ i+1 }}</td>
                            <td>
                                <mat-form-field class="companyName">
                                    <input style="text-align: center;"
                                        type="text" matInput maxlength="25"
                                        formControlName="companyName"
                                        [readonly]='isReadOnly'>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field class="contributions">
                                    <input style="text-align: center;"
                                        type="text" DecimalTrail matInput
                                        maxlength="10"
                                        [textMask]="{mask: twoDecMask}"
                                        formControlName="contribution"
                                        [readonly]='isReadOnly'>
                                    <span matPrefix>$&nbsp;</span>
                                </mat-form-field>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-card>

        <!--Additional Info-->
        <!-- <mat-card fxLayout="column" fxLayoutGap="16px">

            <mat-card-subtitle>If you are a successful awardee, would you prefer
                that the grant payment be made by
                credit card? *</mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-radio-group formControlName="payment"
                    [disabled]='isReadOnly'>
                    <mat-radio-button color="primary" value="CREDIT">Yes</mat-radio-button>
                    <mat-radio-button color="primary" value="CHECK">No</mat-radio-button>
                </mat-radio-group>
            </mat-card-content>

        </mat-card> -->

        <!--Attachments-->
        <mat-card fxLayout="column" fxLayoutGap="16px">

            <mat-card-subtitle> <b>Attachments</b> </mat-card-subtitle>
            <!--W9-->
            <mat-card fxLayout="column" fxLayoutGap="16px">
                <mat-card-subtitle>Please upload a completed form W-9 for this
                    request. <b>(PDF Only)*</b>
                    <br>
                    Please Note: the provided W-9 must be the version
                    <a href="https://lge-ku.com/sites/default/files/W9.pdf"
                        target="_blank">here.</a>
                </mat-card-subtitle>
                <mat-card-content fxLayout="column">
                    <input *ngIf="!isReadOnly" type="file"
                        accept="application/pdf"
                        (change)="onAttachFileChange($event, 'W9Attach')"
                        #fileInputW9>
                    <mat-nav-list fxLayout="column" fxLayoutGap="10px">
                        <a class="list-item" mat-list-item
                            *ngFor="let file of
                            esForm.get('W9Attach')['controls']; let i= index;">
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="primary"
                                *ngIf="esForm.get('W9Attach')['controls'].length
                                != 0"
                                (click)="DownloadAttachFile('W9Attach',
                                file.value.attachName)">
                                save_alt</mat-icon>
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="warn"
                                *ngIf="esForm.get('W9Attach')['controls'].length
                                != 0 &&
                                !isReadOnly"
                                (click)="resetFileInput('W9Attach')">
                                delete_forever</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                {{ file.value.attachName }}
                            </h4>
                        </a>
                    </mat-nav-list>
                    <!-- <mat-nav-list fxLayout="column" fxLayoutGap="10px"
                        *ngIf="esForm.get('W9Attach')['controls'].length != 0">
                        <a class="list-item" mat-list-item
                            *ngFor="let file of esForm.get('W9Attach')['controls']; let i = index; ">
                            <mat-icon class="icon-cursor" mat-list-icon
                                (click)="DownloadAttachFile('W9Attach', file.value.attachName)">
                                save_alt</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                {{ file.value.attachName }}
                            </h4>
                        </a>
                    </mat-nav-list> -->
                </mat-card-content>
            </mat-card>

            <!-- Additonal Attch -->
            <mat-card fxLayout="column">
                <mat-card-subtitle>Additional attachment(s). <b>(PDF Only)</b>
                    <br>
                    (Please upload any other information your organization
                    believes to be pertinent to
                    this request.)
                </mat-card-subtitle>
                <mat-card-content>
                    <input *ngIf="!isReadOnly" type="file"
                        accept="application/pdf"
                        (change)="onAddAttachFileChange($event)"
                        #fileInputAdditional multiple>

                    <mat-nav-list fxLayout="column" fxLayoutGap="10px">
                        <a class="list-item" mat-list-item
                            *ngIf="esForm.get('AddAttach')['controls'].length !=
                            0">
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="primary"
                                (click)="DownloadAllAttachFile()">save_alt
                            </mat-icon>
                            <h4 mat-line style="cursor: default;">
                                <b>Download all files</b>
                            </h4>
                        </a>
                        <a class="list-item" mat-list-item
                            *ngIf="esForm.get('AddAttach')['controls'].length !=
                            0
                            && !isReadOnly">
                            <mat-icon color="warn" class="icon-cursor"
                                mat-list-icon
                                (click)="resetFileInput('AddAttach')">
                                delete_forever</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                <b>Remove all files</b>
                            </h4>
                        </a>
                        <a class="list-item" mat-list-item
                            *ngFor="let file of
                            esForm.get('AddAttach')['controls']; let i= index;">
                            <mat-icon class="icon-cursor" mat-list-icon
                                *ngIf="esForm.get('AddAttach')['controls'].length
                                !=
                                0" color="primary"
                                (click)="DownloadAttachFile('AddAttach',
                                file.value.attachName)">
                                save_alt</mat-icon>
                            <mat-icon class="icon-cursor" mat-list-icon
                                *ngIf="esForm.get('AddAttach')['controls'].length
                                != 0
                                && !isReadOnly" color="warn"
                                (click)="removeAddFile(file.value.attachName)">
                                delete_forever</mat-icon>
                            <h4 mat-line style="cursor: default;">{{i+1}}. {{
                                file.value.attachName }}</h4>
                        </a>
                    </mat-nav-list>

                    <!-- <mat-nav-list fxLayout="column" fxLayoutGap="10px"
                        *ngIf="esForm.get('AddAttach')['controls'].length != 0">
                        <a class="list-item" mat-list-item
                            *ngIf="esForm.get('AddAttach')['controls'].length !=
                            0">
                            <mat-icon class="icon-cursor" mat-list-icon
                                (click)="DownloadAllAttachFile()">save_alt
                            </mat-icon>
                            <h4 mat-line style="cursor: default;">
                                <b>Download all files</b>
                            </h4>
                        </a>
                        <a class="list-item" mat-list-item
                            *ngFor="let file of
                            esForm.get('AddAttach')['controls']; let i= index;">
                            <mat-icon class="icon-cursor" mat-list-icon
                                (click)="DownloadAttachFile('AddAttach',
                                file.value.attachName)">
                                save_alt</mat-icon>
                            <h4 mat-line style="cursor: default;">{{i+1}}. {{
                                file.value.attachName }}</h4>
                        </a>
                    </mat-nav-list> -->
                </mat-card-content>
            </mat-card>

        </mat-card>

        <!--Authorized Representative Signature-->
        <mat-card fxLayout="column" formGroupName="AuthorizedRep"
            fxLayoutGap="15px">
            <div class="info-container">
                <h4 style="color:red"><b>Authorization</b></h4>
                <mat-card-subtitle class="leading-9">

                    <p>
                        The signature of your organization’s authorized
                        representative below obligates your organization
                        to spend any and all funds awarded as a result of this
                        application only for the purpose(s)
                        described within this application. Awarded funds spent
                        for any other purpose will be forfeited,
                        and your organization will be obligated to return any
                        such funds immediately. LG&E, KU/ODP and
                        the Foundation (“Granting Entities”) reserve the right
                        to revoke any award and demand the return
                        of all funds spent for any purpose other than that
                        described in this application or for any
                        other material misrepresentation.
                    </p>
                    <p>
                        A request for applications made by the Granting Entities
                        does not constitute an offer or a
                        commitment to award funds. Your organization should not
                        act in reliance on an assumption that
                        funds will be awarded.
                    </p>
                    <p>
                        This application portal and its content are provided on
                        an “as is” basis. The Granting Entities
                        make no representations or warranties, either express or
                        implied, regarding this application
                        portal or its
                        content, and hereby specifically disclaim any and all
                        such representations or warranties of any
                        kind, including any with respect to the completeness,
                        accuracy, or currency of the content or
                        its suitability for any particular purpose.
                    </p>

                    <p>
                        The Granting Entities do not guarantee continuous,
                        uninterrupted, or secure access to this
                        application portal. Your organization is responsible for
                        the costs it incurs in preparing and
                        submitting any application using the application portal.
                        Use of this application portal is
                        solely at each user’s own risk.
                    </p>
                    <p>
                        The Granting Entities may suspend or terminate any
                        user’s access to this application portal at
                        any time for any reason. The Granting Entities reserve
                        the right at any time, with or without
                        notice or reasons, to discontinue any application
                        process. The Granting Entities, in their sole
                        and exclusive discretion, and with or without notice or
                        reason, may (i) accept or reject any
                        application in whole or in part, (ii) reject all
                        applications, or (iii) withdraw any request for
                        applications at any time before or after submission of
                        applications. The Granting Entities
                        retain the discretion and right to change the criteria
                        for evaluating applications even after a
                        request for applications has been released and/or
                        responses to a request for applications have
                        been received.
                    </p>
                    <p>
                        By submitting an application, your organization
                        represents that it has sufficient intellectual
                        property rights to submit the content of the
                        application. The Granting Entities reserve the
                        right to retain copies of application materials
                        indefinitely. Use of any materials containing or
                        using the Granting Entities’ names, logos or trademarks
                        shall be subject to their prior review
                        and approval. Conditioned upon such approval in Granting
                        Entities’ case, the parties hereby
                        grant each other a free, non-exclusive, limited and
                        revocable license to use their intellectual
                        property solely in accordance with the terms, conditions
                        and intended uses hereof. All other
                        rights are reserved and retained by their respective
                        owner.
                    </p>
                </mat-card-subtitle>

            </div>

            <mat-card-subtitle><b>Verified and submitted by authorized
                    representative*</b></mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <input [readonly]='isReadOnly' type="text"
                        formControlName="name" maxlength="25" matInput
                        placeholder="Name">
                </mat-form-field>
                <mat-form-field fxLayout="row">
                    <input [disabled]='true' formControlName="date" readonly
                        matInput
                        placeholder="Date Drafted/Submitted">
                    <mat-datepicker-toggle [disabled]='true' readonly matSuffix
                        [for]="picker1">
                    </mat-datepicker-toggle>
                    <mat-datepicker readonly #picker1></mat-datepicker>
                </mat-form-field>
            </mat-card-content>

            <mat-card-content fxLayout="column">
                <mat-error>*Application will not be considered unless signed by
                    an authorized representative. </mat-error>
            </mat-card-content>

            <mat-card-subtitle
                *ngIf="esForm.get('AuthorizedRep')['controls'].signature.valid">
                <b>Authorized Signature*: </b>
            </mat-card-subtitle>

            <mat-error
                *ngIf="esForm.get('AuthorizedRep')['controls'].signature.invalid">
                <b>Authorized Signature*: </b>
            </mat-error>

            <mat-card-subtitle>(Please use your mouse to sign in the space
                below)</mat-card-subtitle>
            <mat-card-content fxLayout="row" [fxShow.lt-sm]="false">
                <signature-pad style="border-style: solid; border: #009E49"
                    matInput [options]="signaturePadOptions"
                    (onEndEvent)="drawComplete()" #signaturePad></signature-pad>
            </mat-card-content>

            <mat-card-content fxLayout="row" [fxShow.lt-sm]="false">
                <button *ngIf="!isReadOnly && isShowSaveAsDraft"
                    class="action-button" (click)="drawClear()"
                    color="warn">Clear Signature</button>
            </mat-card-content>

            <mat-card fxShow="false" [fxShow.lt-sm]="true">
                <mat-card-subtitle class="red-warning">
                    The signature pad is not supported with your device's
                    resolution.
                </mat-card-subtitle>
            </mat-card>

        </mat-card>

        <!-- Accounting Distribution -->
        <mat-card *ngIf="isShowAccDist" fxLayout="column" fxLayoutGap="16px">
            <mat-card-subtitle>
                <b>Accounting Distribution *</b>
            </mat-card-subtitle>

            <div class="account-dist-container">

                <table style="padding: 16px" formArrayName="AccDistribution">
                    <thead>
                        <tr>
                            <th>No.</th>
                            <th>Company</th>
                            <th>Project</th>
                            <th>Task</th>
                            <th>Exp-Type</th>
                            <th>Exp-Org</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr [formGroupName]="i"
                            *ngFor="let accDist of
                            esForm.get('AccDistribution')['controls']; let i=
                            index">
                            <td>{{ i+1 }}</td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="company"
                                        [disabled]='!isAccDistEditable'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'company')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let company of
                                            companyData[i]"
                                            [value]="company.code">
                                            {{company.descr}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="project"
                                        [disabled]='!isAccDistEditable'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'project')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let project of
                                            projectData[i]"
                                            [value]="project.project">
                                            {{project.project}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="task"
                                        [disabled]='!isAccDistEditable'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'task')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let task of
                                            taskData[i]" [value]="task.task">{{task.task}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="expType"
                                        [disabled]='!isAccDistEditable'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'expType')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let expType of
                                            expTypeData[i]"
                                            [value]="expType.code">
                                            {{expType.code}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="expOrg"
                                        [disabled]='!isAccDistEditable'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'expOrg')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let expOrg of
                                            expOrgData[i]"
                                            [value]="expOrg.code">
                                            {{expOrg.code}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <input DecimalTrail style="text-align:
                                        center;" type="text" matInput
                                        (change)="onAmountChange($event.target.value,i)"
                                        (input)="calculateTotalAmount()"
                                        maxlength="12" formControlName="amount"
                                        [readonly]='!isAccDistEditable'>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td style="text-align: center;">
                                <b>Total Awarded Amount:</b>
                            </td>
                            <td style="text-align: center;">
                                <span>
                                    <b>$ {{esForm.value.amount}}</b>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-card>

        <!-- Total Amount -->
        &nbsp;
        <mat-card fxLayout="column" *ngIf="isAwardedAmount">
            <mat-card-subtitle>
                <b>Total Awarded Amount</b>
            </mat-card-subtitle>
            <mat-form-field>
                <input DecimalTrail formControlName='amount'
                    [readonly]="isReadOnly || !isAwardedAmountEditable"
                    placeholder="Amount Awarded" maxlength="12"
                    formControlName="amount" matInput type="text"
                    [required]='[3,9,11,23].includes(esForm.value.statusId)'>
                <span matPrefix>$&nbsp;</span>
            </mat-form-field>
        </mat-card>

    </form>

</div>

<div class="action-bar">
    <div matRipple class="action-button warn-button" (click)="onCancel()">Cancel</div>
    <div matRipple class="action-button secondary-button" *ngIf="isShowSaveAsDraft"
        (click)="onSaveAsDraft()">Save
        As Draft</div>
    <div matRipple class="action-button primary-button" *ngIf="isShowSaveAsDraft"
        (click)="onSubmit()">Submit</div>
    <div matRipple class="action-button secondary-button" *ngIf="isShowSaveButton"
        (click)="onSubmit()">Save
        Change(s)</div>
    <div matRipple class="action-button warn-button" *ngIf="isShowApproveBtn"
        (click)="onWithdrawReject('Rejected')">Reject</div>
    <div matRipple class="action-button primary-button" *ngIf="isShowApproveBtn"
        (click)="onApprove()">Approve</div>
    <!-- <div matRipple class="action-button" *ngIf="isShowReassignBtn" (click)="onWithdrawReject('Reassigned')"
        color="primary">Reassign To CIT</div> -->
    <div matRipple class="action-button warn-secondary-button" *ngIf="isShowWithdrawBtn"
        (click)="onWithdrawReject('Withdrawn')">Withdraw</div>
</div>